/* eslint-disable */
import React, { useState } from "react";
import EmptySpaceFieldValid from "./EmptySpaceFieldValid";
import { API_URL, COURIER_EXPORT_COURIER_URL, STORE_EXPORT_STOCK_ACCESSORIES_URL, WAREHOUSE_EXPORT_DISPATCH_URL, EXPORT_SALES_PERSON_PERFORMANCE_API_URL, EXPORT_TICKETS_API_URL } from "../Shared/constant";
import { Button, OverlayTrigger, Tooltip, Form, Image } from "react-bootstrap";
import PropTypes from "prop-types";
import {useSelector} from "react-redux";
import generatePDF from "./generatePDF";
import SearchIcon from "../../assets/img/table_search_box.png";
import ExelIcon from "../../assets/img/XLS_icon.svg";
import AddMoreIcon from "../../assets/img/add_btn_icon.svg";
import CommonDatePicker from "./CommonDatePicker";

const DataTableFilter = (props) => {
    const { filterType, searchType, buttonvisible, userSearch, ActiveInactiveFilter, setCurrentPage, ButtonSet, exportVisible, setUserSearch, userType, userLimit, setUserLimit, SelectUserTypeFnct, searchdisable, ParentChildFilter, SelectFranchiseUserTypeFnct, userTeamFilter, setUserTeamFilter, SelectsetWHType, WHType, FilterOpen, setFilterOpen, deviceType, setDeviceType, promoEligible, setPromoEligible, NormalReturnFlag, setNormalReturnFlag, IsSpares, setIsSpares, setStatusTickets, statusTickets, regionSelect, setRegionSelect, downloadPdf, Frequency, setFrequency, replacefilterhide, dateRange, setDateRange, isDistributor, setisDistributor, promoSearch, setPromoSearch, promoSearchDisable } = props;
    const [ CommonSearchUpdate, setCommonSearchUpdate ] = useState("");
    const [ PromoSearchUpdate, setPromoSearchUpdate ] = useState("");
    const { selfInfo, Regionlistall } = useSelector((state) => state.adminReducers);
    const optionsRegion = Regionlistall?.filter((elm) => elm?.is_active === true)?.map((item, index)=>({key:item.id, value:item?.id , label:item?.region_name }));

    const filtertype=props?.filterType
    // export files
    const ExportBtn = () => {
        if(filterType === "Product") {
            window.open(API_URL + "product/export_product", '_blank');
        } else if(filterType === "Product Applications") {
            window.open(API_URL + "product/export_brand", '_blank');
        } else if(filterType === "Category") {
            window.open(API_URL + "product/export_category", '_blank');
        } else if(filterType === "Sub Category"){
            window.open(API_URL + "product/export_sub_category", '_blank');
        } else if(filterType === "Warehouse") {
            window.open(API_URL + "warehouse/export_warehouse", '_blank');
        } else if(filterType === "Frame Number") {
            window.open(API_URL + "store/export_stock_frame", '_blank');
        } else if(filterType === "Region Master") {
            window.open(API_URL + "warehouse/export_region", '_blank');
        } else if(filterType === "States") {
            window.open(API_URL + "warehouse/export_state", '_blank');
        } else if(filterType === "Cities") {
            window.open(API_URL + "warehouse/export_district", '_blank');
        } else if(filterType === "Franchise User Report") {
            // window.open(API_URL + "franchise/export_franchise", '_blank');
            exportToCSV("franchiseUserReportData", "isCollapsable");
        } else if(filterType === "Franchise Type") {
            window.open(API_URL + "franchise/export_franchise_type", '_blank');
        } else if(filterType === "Courier") {
            window.open(COURIER_EXPORT_COURIER_URL, '_blank');
        } else if(filterType === "Accessories") {
            window.open(STORE_EXPORT_STOCK_ACCESSORIES_URL, '_blank');
        } else if(filterType === "Dispatch") {
            window.open(WAREHOUSE_EXPORT_DISPATCH_URL, '_blank');
        } else if(filterType === "GSTreport") {
            exportToCSV(filterType, "no-isCollapsable");
        } else if(filterType === "SummaryDetails") {
            exportToCSV(filterType, "no-isCollapsable");
        } else if(filterType === "Stock Inward Log Details") {
            exportToCSV("StockInwardLogDetails", "no-isCollapsable");
        } else if(filterType === "ErpOutstandingReport") {
            exportToCSV("ErpOutstandingReport", "no-isCollapsable");
        } else if(filterType === "ErpSummaryDetails") {
            exportToCSV("ErpSummaryDetails", "no-isCollapsable");
        } else if(filterType === "salesPersonPerformance") {
            exportToCSV("salesPersonPerformance", "no-isCollapsable");
            // window.open(EXPORT_SALES_PERSON_PERFORMANCE_API_URL, '_blank');
        } else if(filterType === "Ticket_filters") {
            window.open(EXPORT_TICKETS_API_URL, '_blank');
        } else if(filterType === "ErpSummaryGeneralDetails") {
            exportToCSV("ErpSummaryGeneralDetails", "no-isCollapsable");
        } else if(filterType === "ERP_sales_order") {
            exportToCSV("erp-api-failures-Sales-Order", "no-isCollapsable");
        } else if(filterType === "Franchise Report") {
            exportToCSV("FranchiseReportsData", "no-isCollapsable");
        } else if(filterType === "Users") {
            exportToCSV("user-list", "no-isCollapsable");
        } else if(filterType === "purchase_list") {
            exportToCSV("purchase-list", "no-isCollapsable");
        } else if(filterType === "sales_person_purchase_list") {
            exportToCSV("sales-person-purchase-list", "no-isCollapsable");
        };
    };

    function exportToCSV(filterType, url) {
        let table = document.getElementById(filterType);

        if (!table) {
            console.error(`Table with ID "${filterType}" not found.`);
            return;
        };

        let rows = table.querySelectorAll('tr');
        let csvContent = "";

        rows.forEach(row => {
            let cols = row.querySelectorAll('th, td');
            let rowData = [];

            cols.forEach(col => {
                let cellText = col.innerText.replace(/,/g, ''); // Escape double quotes
                if(cellText !== "" && cellText !== "Action") {
                    rowData.push(`${cellText}`); // Wrap each cell in quotes
                };
            });

            if (rowData.length > 0) {
                csvContent += rowData.join(",") + "\n";
            };
        });
        
        let blob = new Blob([csvContent], { type: 'text/csv' });
        let link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filterType + '.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const onEnterSearch = (e) => {
        const code = e.which || e.keyCode;
        if(code === 13) {
            setCurrentPage(1);
            OnEnterSearch();
        };
    };

    // search box
    const OnEnterSearch = () => {
        setUserSearch(CommonSearchUpdate);
    };

    const onEnterPromoSearch = (e) => {
      const code = e.which || e.keyCode;
      if (code === 13) {
        setCurrentPage(1);
        OnEnterPromoSearch();
      }
    };
    

    // search box
    const OnEnterPromoSearch = () => {
      setPromoSearch(PromoSearchUpdate);
    };
    

    // select limit
    const SelectLimitFct = (e) => {
        setUserLimit(parseInt(e.target.value));
        setCurrentPage(1);
    };

    // select team
    const SelectUserTeamTypeFnct = (e) => {
        setUserTeamFilter(e.target.value);
        setCurrentPage(1);
    };

    // clear search box
    const ClearSearchFiled = () => {
        setUserSearch("");
        setCommonSearchUpdate("");
    };

    const ClearPromoSearchFiled = () => {
      setPromoSearch("");
      setPromoSearchUpdate("");
    };

    const onChangeIsDistributor = (e) => {
        setisDistributor(e.target.value);
        setCurrentPage(1);
    };

    // download pdf 
    const DonwloadPDFfile = (filterType) => {
        if(filterType === "ErpOutstandingReport") {
            generatePDF(filterType, "Erp General Outstanding Report");
        } else if(filterType === "ErpSummaryGeneralDetails") {
            generatePDF(filterType, "Erp Summary General Details");
        };
    };

    // clear after delete button hit
    document.addEventListener('keydown', function(event) {
        var keyPressed = event.key;
        if (keyPressed === 'Delete') {
            ClearSearchFiled();
        }
    });

    return(<div className={filterType === "salesPersonPerformance" ? "card-header-New card-header-salesPerson" : "card-header-New"}>
        {searchdisable && (<div className={`searchBoxwithbtn ${userSearch !== ""?"search":""}`}>
            <input 
                type="text" 
                className="form-control" 
                value={CommonSearchUpdate} 
                onKeyDown={(e) => {onEnterSearch(e); EmptySpaceFieldValid(e)}} 
                onChange={(e) => setCommonSearchUpdate(e.target.value)} 
                placeholder={`Search ...`}
            />
            <Button className="searchbtn" onClick={() => OnEnterSearch()}>
                <Image src={SearchIcon} alt="search_btn" />
            </Button>
            {userSearch !== "" && (
                <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 100 }}
                overlay={<Tooltip style={{ position: "fixed" }} id="button-tooltip" {...props}>
                Clear the search by using the delete key.
            </Tooltip>}
            >
                <i className="bi bi-x-circle-fill searchclear" onClick={() => ClearSearchFiled()}></i>
            </OverlayTrigger>)}
            
            <OverlayTrigger
                placement="right"
                delay={{ show: 250, hide: 100 }}
                overlay={<Tooltip style={{ position: "fixed" }} id="button-tooltip" {...props}>
                Search using {searchType ? `(${searchType})`:""}
            </Tooltip>}
            >
                <i className="searchInfo bi bi-info-circle-fill"></i>
            </OverlayTrigger>
        </div>)}
        {filterType === "ErpSummaryGeneralDetails" && (<div className="col-md-4" style={{ width: "25%", float: "left", marginLeft: "15px" }} >
            <div className="common_datepicker">
                <CommonDatePicker 
                    dateRange={dateRange} 
                    setDateRange={setDateRange}
                    placeholderText={"Select Posting start & end date"}
                    dependantState={{
                        allow: true,
                        statType: "current_page",
                        stateFunction: setCurrentPage
                    }} 
                />
            </div>
        </div>)}
        <div className="card-header-right">   
            {filterType === "ERP_sales_order" && (<div className="order_bunddle_checkboxes">
                <Form.Label>
                    <Form.Check
                        type="checkbox"
                        checked={IsSpares}
                        onChange={(e) => setIsSpares(!IsSpares)}
                    />
                    Spares Orders
                </Form.Label>
            </div>)}
            {filterType === "Warehouse" && (<select className="form-control activestatusselet" id="FranchiseUserReportWidth" value={WHType} onChange={(e) => {SelectsetWHType(e); setCurrentPage(1);}}>
                <option value="">All</option>
                <option value="E-Bikes, Transportation Charges">E-Bikes</option>
                <option value="Spares, Service, Transportation Charges">Spares</option>
                <option value="Accessories, Transportation Charges">Accessories</option>
                <option value="Marketing, Transportation charges">Marketing</option>
            </select>)}     
            {filterType === "Franchise User Report" && (<select 
                className="form-control activestatusselet" 
                id="FranchiseUserReportWidth" 
                value={isDistributor} 
                onChange={(e) => onChangeIsDistributor(e)}
            >
                <option value="">All Dealer Type</option>
                <option value="dealer">Dealer</option>
                <option value="distributor">Distributor</option>
            </select>)}
            {(filterType === "Franchise User Report" && filterType === "Franchise Report") && (<select className="form-control activestatusselet" id="FranchiseUserReportWidth" value={ParentChildFilter} onChange={(e) => {SelectFranchiseUserTypeFnct(e); setCurrentPage(1);}}>
                <option value="">All</option>
                <option value="Dealer">Dealer</option>
                <option value="SubDealer">Sub Dealer</option>
            </select>)}
            {(filterType === "purchase_list" || filterType === "purchase_log_list") && (<select className="form-control activestatusselet" id="FranchiseUserReportWidth" value={deviceType} onChange={(e) => {setDeviceType(e.target.value); setCurrentPage(1);}}>
                <option value="">All</option>
                <option value="app">App</option>
                <option value="web">Web</option>
                <option value="customer">Customer</option>
            </select>)}
            {(filterType === "purchase_list") && (<select className="form-control activestatusselet" id="promoeleigibility" style={{width:"220px"}} value={promoEligible} onChange={(e) => {setPromoEligible(e.target.value); setCurrentPage(1);}}>
                <option value="">Select Promocode Eligibility</option>
                <option value="ACCEPTED">ACCEPTED</option>
                <option value="REJECTED">REJECTED</option>
            </select>)}
            {promoSearchDisable && (<div className={`searchBoxwithbtn ${userSearch !== ""?"search":""}`}>
                <input 
                    type="text" 
                    className="form-control" 
                    value={PromoSearchUpdate} 
                    onKeyDown={(e) => {onEnterPromoSearch(e); EmptySpaceFieldValid(e)}} 
                    onChange={(e) => setPromoSearchUpdate(e.target.value)} 
                    placeholder={`Search using promo code`}
                />
                <Button className="searchbtn" onClick={() => OnEnterSearch()}>
                    <Image src={SearchIcon} alt="search_btn" />
                </Button>
                {promoSearch !== "" && (
                    <OverlayTrigger
                    placement="right"
                    delay={{ show: 250, hide: 100 }}
                    overlay={<Tooltip style={{ position: "fixed" }} id="button-tooltip" {...props}>
                    Clear the search by using the delete key.
                </Tooltip>}
                >
                    <i className="bi bi-x-circle-fill searchclear" onClick={() => ClearPromoSearchFiled()}></i>
                </OverlayTrigger>)}
                
                <OverlayTrigger
                    placement="right"
                    delay={{ show: 250, hide: 100 }}
                    overlay={<Tooltip style={{ position: "fixed" }} id="button-tooltip" {...props}>
                    Search using Promo Code
                </Tooltip>}
                >
                    <i className="searchInfo bi bi-info-circle-fill"></i>
                </OverlayTrigger>
            </div>)}
            {filterType === "erp_api_failures_delivery_note" && (<select className="form-control activestatusselet" id="FranchiseUserReportWidth" value={NormalReturnFlag} onChange={(e) => {setNormalReturnFlag(e.target.value); setCurrentPage(1);}}>
                <option value="normal">Normal</option>
                <option value="return">Return</option>
                {!replacefilterhide && (<option value="replace">Replace</option>)}
            </select>)}
            {filterType === "Ticket_filters" && (<React.Fragment>
                <select className="form-control activestatusselet" id="FranchiseUserReportWidth" value={regionSelect} onChange={(e) => {setRegionSelect(e.target.value); setCurrentPage(1);}}>
                    <option value="">Select Region</option>
                    {optionsRegion?.map((elm, index) => {
                        return(<option key={index} value={elm?.value}>{elm?.label}</option>)
                    })}
                </select>
                <select className="form-control activestatusselet" id="FranchiseUserReportWidth" value={statusTickets} onChange={(e) => {setStatusTickets(e.target.value); setCurrentPage(1);}}>
                    <option value="">Select Status</option>
                    <option value="Open">Open</option>
                    <option value="On Hold">On Hold</option>
                    <option value="Escalated">Escalated</option>
                    <option value="Dispatched">Dispatched</option>
                    <option value="Delivered">Delivered</option>
                    <option value="Closed">Closed</option>
                    <option value="Failed">Failed</option>
                </select>
            </React.Fragment>)}
            {(props?.orderSource != null && selfInfo?.user?.user_type === 'super_admin') && (
                <select className="form-control activestatusselet pe-4" id="FranchiseUserReportWidthNew" value={props?.orderSource} onChange={(e) => {props?.callSelectSource(e.target.value); setCurrentPage(1);}}>
                    <option value="">All</option>
                    <option value="FO">Dealer</option>
                    <option value="CO">Sale</option>
                    <option value="WO"> Internal Warehouse to Warehouse</option>
                    <option value="AO">Amazon, Website, Flipkart</option>
                </select>
            )}
            {filterType === "Users" && (<select className="form-control selectuserteamDrop" value={userTeamFilter} onChange={(e) => SelectUserTeamTypeFnct(e)}>
                <option value={""}>Search Team</option>
                <option value={"super_admin"}>Super Admin</option>
                <option value={"admin"}>Admin</option>
                <option value={"sales_operations"}>Sales Operations</option>
                <option value={"warehouse_manager"}>Warehouse Manager</option>
                <option value={"inventory_operations"}>Inventory Operations</option>
                <option value={"logistics_ops"}>Logistics Ops</option>
                <option value={"accounts"}>Accounts</option>
                <option value={"regional_sales_team"}>Regional Sales Team</option>
                <option value={"inside_sales"}>Inside Sales</option>
                <option value={"ecommerce"}>Ecommerce</option>
                <option value={"sale_franchise_person"}>Sale Franchise Person</option>
                <option value={"franchise_manager"}>Franchise Manager</option>
                <option value={"after_sales_and_service"}>After Sales and Service</option>
            </select>)}
            {filterType === "payment_approval_listing" && (<select className="form-control selectuserteamDrop" value={userType} onChange={(e) => SelectUserTypeFnct(e)}>
                <option value={"all"}>All</option>
                <option value={"approved"}>Approved</option>
                <option value={"pending"}>Pending</option>
            </select>)}
            {filterType === "Notifications" && (
                <select 
                    className="form-control selectuserteamDrop" 
                    value={Frequency} 
                    onChange={(e) => {
                        setFrequency(e.target.value);
                        setCurrentPage(1);
                    }}
                >
                    <option value={""}>All Frequency</option>
                    <option value={"daily"}>Daily</option>  
                    <option value={"weekly"}>Weekly</option>
                    <option value={"monthly"}>Monthly</option>
                    <option value={"quarterly"}>Quarterly</option>
                    <option value={"custom"}>Custom</option>
                </select>
            )}
            {ActiveInactiveFilter && (<select className="form-control activestatusselet" value={userType} onChange={(e) => SelectUserTypeFnct(e)}>
                <option value="all">All</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
            </select>)}
            {(filterType === "Product" || filterType === "Payment-Approval" || filterType === "debit-credit-note-report" || filterType === "GSTreport" || filterType === "Account Ledger Report" || filterType === "Franchise User Report" || filterType === "Franchise Report") ? (<select className="form-control userLimitselect" value={userLimit} onChange={(e) => SelectLimitFct(e)}>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="40">40</option>
                <option value="50">50</option>
                <option value="60">60</option>
                <option value="70">70</option>
                <option value="80">80</option>
                <option value="90">90</option>
                <option value="100">100</option>
                <option value="200">200</option>
                <option value="500">500</option>
                {(filterType !== "Franchise User Report" || filterType === "Franchise Report") && (<option value="1000">1000</option>)}
            </select>) : (<select className="form-control userLimitselect" value={userLimit} onChange={(e) => SelectLimitFct(e)}>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="40">40</option>
                <option value="50">50</option>
                <option value="60">60</option>
                <option value="70">70</option>
                <option value="80">80</option>
                <option value="90">90</option>
                <option value="100">100</option>
            </select>)}
            {downloadPdf && (<OverlayTrigger
                placement="left"
                delay={{ show: 250, hide: 100 }}
                overlay={<Tooltip style={{ position: "fixed" }} id="button-tooltip" {...props}>
                Download PDF
            </Tooltip>}>
                <button className="btn downloadbtn" id="downloadbtn" onClick={() => DonwloadPDFfile(filterType)} >
                    <i className="bi bi-filetype-pdf"></i>
                </button>
            </OverlayTrigger>)}
            {(filterType !== "MarketCampaigns" && filterType !== "Payment-Approval" && filterType !== "Notifications" && filterType !== "debit-credit-note-report" && filterType !== "Account Ledger Report" && filterType !== "Pincodes" && filterType !== "EwayBill" && filterType !== "Product Group" && filterType !== "Product Group" && filterType !== "Frame Number" && filterType !== "purchase_log_list" &&  filterType !== "payment_approval_listing" && filterType !== "") && (<OverlayTrigger
                placement="left"
                delay={{ show: 250, hide: 100 }}
                overlay={<Tooltip style={{ position: "fixed" }} id="button-tooltip" {...props}>
                Download Excel
            </Tooltip>}>
                <button className="btn exportbtnMain" id="exportbtnMain" onClick={() => ExportBtn()} >
                    <Image src={ExelIcon} alt="excel" />
                </button>
            </OverlayTrigger>)}
            {buttonvisible && (<button className="btn head_cmn_btn" style={{ marginLeft: filterType === "Users" ? "10px" : "0px" }} onClick={ButtonSet?.function}>
                <Image src={AddMoreIcon} alt="addmore" />
                {ButtonSet?.buttontitle}
            </button>)}
            {(filterType === "Franchise User Report" || filterType === "Franchise Report") && (<OverlayTrigger
                placement="bottom"
                delay={{ show: 250, hide: 100 }}
                overlay={<Tooltip style={{ position: "fixed" }} id="button-tooltip" {...props}>
                    {FilterOpen ? "Filter Hide" : "Filter Show"}
                </Tooltip>}
            >
                <button
                    className="filtercollapsebtn"
                    style={{ marginLeft: "10px" }}
                    onClick={() => setFilterOpen(!FilterOpen)}
                    aria-controls="example-collapse-text"
                    aria-expanded={FilterOpen}
                >
                    {FilterOpen ? (<i className="bi bi-funnel-fill"></i>) : (<i className="bi bi-funnel"></i>)}
                </button>
            </OverlayTrigger>)}
        </div>
    </div>)
}
DataTableFilter.propTypes = {
    orderSource: PropTypes.any,
    callSelectSource: PropTypes.func,
}
DataTableFilter.defaultProps = {
    orderSource: null,
    callSelectSource: ()=>{},
}
export default DataTableFilter;
